import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import AgreementDocumentSetTable from "components/charging/SiteAccessPolicyComponent/AgreementDocumentSetTable";
import { Box, CircularProgress, Typography } from '@mui/material';
import { useApiService } from "../../services/ApiService/ApiService";

function AgreementDocumentsListPage(props: any) {
  const { userInfo } = useContext(UserContext);
  const { fetchWithAuth } = useApiService();
  const [documentSets, setDocumentSets] = useState() as any;
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchDocumentSets = async () => {
    let bodyData: { [name: string]: string } = {};

    bodyData["uuid"] = userInfo.uuid;
    bodyData["businessUuid"] = userInfo.businessUuid;
    
    try {
      const response = await fetchWithAuth('/charging-partner/agreement-document-set/list', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyData)
      });

      if (response.status !== 200) {
        setIsError(true);
        return;
      }

      const res_json = await response.json();
      setDocumentSets(res_json.documentSets.map((e: any) => ({ ...e, id: e.uuid, name: e.name })));
    } catch (error) {
      setIsError(true);
      console.error('Error fetching document sets:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocumentSets();
  }, []);

  if (loading) {
    return (
      <Box 
        component="section" 
        sx={{ p: 3 }}
      >
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      </Box>
    );
  }

  return (
    <Box 
      component="section"
      sx={{ p: 3 }}
    >
      <Box sx={{ width: '100%' }}>
        {documentSets?.length === 0 ? (
          <Typography variant="body1" textAlign="center" color="text.secondary">
            No agreement documents found
          </Typography>
        ) : (
          <AgreementDocumentSetTable documentSets={documentSets} />
        )}
      </Box>
    </Box>
  );
}

export default AgreementDocumentsListPage;
